
import {storePdp} from "@/store/product-page";
import Vue from 'vue';
import {ObserveVisibility} from 'vue-observe-visibility';
import { HistoryPosition } from '@/models/Blocks/history-position';

import Single from '@/components/Blocks/Block/Single.vue';
import RelatedList from "@/models/Product/related-list";
import productPage from "@/api/productPage";
import utilities from "@/Utilities/common";
import request from "@/Utilities/httpRequest";
import baseUrl from "@/api/base-url";

Vue.directive('observe-visibility', ObserveVisibility);

export default {
    store: storePdp,
    name: 'RelatedProductsBlocks',
    components: {
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
        ProductDisplay: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/ProductDisplay.vue'),
        //Single: () => import('@/components/Blocks/Block/Single.vue'),
        Single
    },
    props: {
        preLoad: {
            type: Boolean,
            default: false,
        }
    },
    created() {
    },
    data() {
        let relatedProductsData: Array<any> = [];
        let relatedBlockKey: any = null;
        let typeHistory: string = 'relatedBlocksStorage';
        let blocksData: any = null;
        return {
            loading: false, // not used for now
            visible: false,
            hideSection: false,
            listTitle: '',
            relatedProductsData, // related products display modals
            relatedBlockKey, // block key of related products
            typeHistory,
            blocksData
        }
    },
    computed: {
        groupId() {
            return this.$store.getters.GroupId;
        },
        relatedProductsBlocks(): Array<any> {
            //const blocksData = this.$store.getters['pdpDesktop/relatedProductsBlocks'];
            return this.blocksData && this.blocksData.length > 0 ? productPage.singleBlockFactory(this.blocksData) : [];
        },
        basicInfo() {
            return this.$store.getters['pdpDesktop/basicInfoData'];
        }
    },
    watch: {
        async preLoad(value) {
            if(value) {
                await this.loadRelated();
                await this.load();
            }
        }
    },
    methods: {
        async handleRelatedModal(blockValue: any, status = true, addHistory: boolean = true) { // match with and other related products -> opens a modal with a list
            let key   = blockValue?.modalKey??null;
            if(status && this.relatedBlockKey && key && this.relatedBlockKey == key) {
                return this.scrollRelatedIntoView();
            }

            let hash  = window?.location?.hash??null;
            if(hash && addHistory){
                await history.back();
            }
            if(!status){
                await history.back();
                return;
            }
            this.listTitle          = blockValue.modalTitle;
            let relatedBlockKey     = blockValue.modalKey ?? '-';
            let url = blockValue.url ?? null;
            let related = [];
            if(url){
                this.$emit('isLoading', true);
                related = await productPage.getModalContent(url,(blockValue.data??{}),relatedBlockKey)
                this.$emit('isLoading', false);
            }else{
                related = productPage.singleBlockFactory(blockValue.openProductsList, relatedBlockKey);
            }
            this.setShowPagePopup(blockValue.modalTitle??'',relatedBlockKey,related,blockValue, addHistory)
        },
        async setShowPagePopup(title: string, key: string, list: any[], dataHistory: any, addHistory: boolean = true){
            this.listTitle = title;
            this.relatedProductsData = list;
            this.relatedBlockKey = key;

            if(addHistory){
                let related = new RelatedList(this.typeHistory);
                related.save(dataHistory,this.groupId);
            }
        },
        initHistoryPopState() { // back on open modals
            window.addEventListener('popstate', event => {
                this.removeModal();
            });
        },
        removeModal(){
            this.listTitle = '';
            this.relatedProductsData = [];
            this.relatedBlockKey = null;
        },
        async visibilityRow(isVisible: boolean) {
            if (isVisible) {
                await this.loadRelated();
                await this.load();
            }
        },
        async loadRelated(){
            this.loading = true;
            let url = baseUrl.getUrl('product/block-related');
            if(url && this.blocksData === null){
                let hasStock = this.basicInfo.hasStock??null; 
                let params: any =  {id: this.groupId, hasStock: (hasStock == true || hasStock == null ? 1 : 0)};
                let response: any = await request.get(url, params, true);
                if(!response?.hasError){
                    this.blocksData = response?.data?.blocks??[];
                }
            }
            this.loading = false;
        },
        async load() {
            this.loading = true;
            this.visible = true;

            if (!this.relatedProductsBlocks || this.relatedProductsBlocks.length == 0) {
                this.hideSection = true;
            }

            try{
                if(HistoryPosition.isBack()){
                    let related = new RelatedList();
                    if ((related.groupId == this.groupId) && related.getData() && related.getType() == this.typeHistory) {
                        this.handleRelatedModal(related.getData(), true, false);
                    }
                }
            } catch(e) {}
            this.loading = false;
        },
        // auto opening requires some time, must go to the last opened item too
        scrollRelatedIntoView(position = 76, timeout = 100) {
            const pdpRelatedBlocks = document.getElementById('pdpRelatedBlocks');
            if(pdpRelatedBlocks) {
                utilities.scrollIntoViewWithOffset(pdpRelatedBlocks, position, timeout);
            } else {
                setTimeout(() => {
                    window.scrollTo({
                        behavior: 'smooth',
                        top: position
                    });
                }, timeout);
            }
        },
        itemClickHandler(item: any, targetElm: HTMLElement| undefined = undefined) {
            if(!item) {
                return
            }
            if(targetElm) {
                this.$emit('isLoading', true);
            }
        }
    },
    async mounted() {
        this.$nextTick(() => {
            this.initHistoryPopState();
        });

        if(this.preLoad) {
            await this.loadRelated();
            await this.load();
        }
    }
}

